import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotificationLayout } from '../../../shared/layout/notification-layout/notification-layout';

@Component({
  selector: 'app-user-cancel',
  imports: [RouterLink, NotificationLayout],
  templateUrl: './user-cancel.html',
  styleUrl: './user-cancel.scss',
})
export class UserCancel {}
